import React, { useContext, useEffect } from "react";
import { LanguageContext } from "./LanguageContext";
import "./css/TutoringPage.css";

const TutoringCoachPage = () => {
  const { language } = useContext(LanguageContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const isPT = language === "pt";

  return (
    <div className="tutoring-page">
      <main>
        <h1 className="tutoring-title">
          {isPT ? (
            <>Programa de <span>Coaching</span></>
          ) : (
            <><span>Coaching</span> Program</>
          )}
        </h1>

        <section className="program-info">
          <h2>
            {isPT
              ? "Por que o Programa de Coaching da Invest DECODED é Diferente?"
              : "Why Invest DECODED's Coaching Program is Different"}
          </h2>

          <p>
            {isPT
              ? "Tomar decisões financeiras nunca foi tão desafiador. O mercado muda rápido e, muitas vezes, fica difícil saber qual é o próximo passo."
              : "Making financial decisions has never been more challenging. Markets move fast, and it's easy to feel unsure about the next step."}
          </p>

          <p>
            {isPT
              ? "O nosso Programa de Coaching foi criado para te dar clareza, método e confiança para investir de forma estratégica — com um plano que faz sentido para a sua realidade nos EUA."
              : "Our Coaching Program is designed to give you clarity, a repeatable method, and confidence to invest strategically—with a plan tailored to your real life in the U.S."}
          </p>

          <p>
            {isPT
              ? "Durante o coaching, você recebe orientação personalizada para organizar finanças, definir metas, estruturar sua estratégia (conta, ETFs, alocação, aportes) e evitar erros comuns que custam caro."
              : "In coaching, you get personalized guidance to organize your finances, set goals, build your strategy (accounts, ETFs, allocation, contributions), and avoid costly mistakes."}
          </p>

          <p>
            {isPT
              ? "Se você está começando do zero ou quer ajustar sua estratégia com mais precisão, o coaching te ajuda a sair da dúvida e ir para a execução com consistência."
              : "Whether you're starting from zero or refining your approach, coaching helps you move from uncertainty to consistent execution."}
          </p>

          <p className="highlight-text">
            {isPT
              ? "✨ Domine os investimentos. Decodifique o sucesso. ✨"
              : "✨ Master investing. Decode success. ✨"}
          </p>
        </section>

        <section className="contact-form">
          <h2>{isPT ? "Entre em Contato" : "Contact Us"}</h2>
          <p>{isPT ? "Envie um email para:" : "Send an email to:"}</p>
          <a href="mailto:investdecoded@investdecoded.com" className="email-link">
            investdecoded@investdecoded.com
          </a>
        </section>
      </main>
    </div>
  );
};

export default TutoringCoachPage;
